<template>
<div id="kt_table_1_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer variants-listing-wrapper">
    <div class="row ">
        <div class="col-sm-12">
            <div class="dataTables_scroll">
                <table id="product-variants-table" class="table text-center table-checkable dataTable no-footer" role="grid">
                    <thead>
                        <tr role="row">
                            <th class="text-left">{{$t('image')}}</th>
                            <th class="text-left" v-if="!($store.getters.role =='customer-contact' && $store.getters.brand.hide_sku_on_shop=='1')">{{$t('sku')}}</th>
                            <th class="w-120px text-left">{{$t('name')}}</th>
                            <th class="w-50px text-left " v-if="retail_price == 1  && $store.getters.brand.hide_price_shop_view=='0' ">{{msrpName}}</th>
                            <th class="w-50px text-left " v-if="$store.getters.brand.hide_price_shop_view=='0'">{{$t('wholesale')}}</th>
                            <th v-if="track_inventory" class="w-90px text-left">{{$t('available_inventory')}}</th>
                            <th class="text-left w-140px" aria-label="Actions">{{$t('quantity')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(product, index) in productVariants" :key="index">
                            <td class="text-left">
                                <img v-if="product.image != null" :src="getBrandImageUrl(product.formatted_images.default_image)"  alt="image" class="img-fluid"/>
                                <img v-else src="/images/no-image-500x500.jpg" alt="image" class="img-fluid"/>
                            </td>
                            <td class="text-left" v-if="!($store.getters.role =='customer-contact' && $store.getters.brand.hide_sku_on_shop=='1')">{{product.sku}}</td>
                            <td class="text-left" @click="openDetails(product)"><a href="javascript:;">{{product.name}}</a></td>
                            <td class="text-left" v-if="retail_price == 1  && $store.getters.brand.hide_price_shop_view=='0' ">{{product.currency_symbol}}{{formatPrice(product.rp)}}</td>
                            <td class="text-left" v-if="$store.getters.brand.hide_price_shop_view=='0'">{{product.currency_symbol}}{{getWholesalePrice(product, quantities[product.id] || (product.min_pur_qty || 1))}}</td>
                            <td class="text-left" v-if="track_inventory">{{product.settings.inventory_level}}</td>
                            <td class="variant-quantity-cell" nowrap="">
                                <div class="row">
                                    <div  v-if="settings.min_qty_multiples" class="col-md-5 col-sm-12 p-1">
                                        <input class="form-control" :id="product.id + '-quantity'" type="number" :min="product.min_pur_qty == null ? 1 : product.min_pur_qty" :max="ProductMaxQuantity" :step="product.min_pur_qty == null ? 1 : product.min_pur_qty" placeholder="Qty" :value="quantities[product.id] !== undefined ? quantities[product.id] : (product.min_pur_qty || 1)" @input="updateQuantity(product.id, $event.target.value)" :disabled="quantityDisable">
                                    </div>
                                    <div v-else class="col-md-5 col-sm-12 p-1">
                                        <input class="form-control" :id="product.id + '-quantity'" type="number" :min="product.min_pur_qty == null ? 1 : product.min_pur_qty" :max="ProductMaxQuantity" step="1" placeholder="Qty" :value="quantities[product.id] !== undefined ? quantities[product.id] : (product.min_pur_qty || 1)" @input="updateQuantity(product.id, $event.target.value)" :disabled="quantityDisable">
                                    </div>
                                    <div class="col-md-7 col-sm-12">
                                        <button type="button" :id="product.id + '-button'" class="btn btn-success addToCart" @click="addProductToCart(product,index)" v-if="!product.so">{{$t('add_to_cart')}}</button>
                                        <button v-else class="btn btn-secondary">{{$t('sold_out')}}</button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <HtmlTableMobileCards table-id="product-variants-table" :column-options="{ quantity: { role: 'primary' } }"/>
            </div>
        </div>
    </div>
</div>
</template>
<script setup>
import ShopAPIService from '@/js/api/store/shop';
import {ref, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import eventBus from '@/js/utils/eventBus';
import {toast} from "vue3-toastify";
import 'vue3-toastify/dist/index.css';
import { getBrandImageUrl } from '@/js/utils/common.js';
import HtmlTableMobileCards from '@/js/ordercircle/components/HtmlTableMobileCards.vue';

const { t } = useI18n();
const product = ref('');
const quantity = ref(0);
const min = ref(1);
const step = ref(1);
const selectedVariant = ref('');
const quantityDisable = ref(false);
const ProductMaxQuantity = ref(999999);
const quantities = ref({});
const store = useStore();
const APIURL = import.meta.env.VITE_API_URL;
const props = defineProps({
    productVariants: {
        type: Array,
        required: true,
    },
    settings: {
        type: Object,
        required: false,
    },
    track_inventory:{
        type:Number,
        required: true,
    },
    retail_price:{
        type:String,
        required: true,
    },
    msrpName:{
        type:String,
        required: true,
    },
});

const getWholesalePrice = (product, qty) => {
    // If no VPT → normal logic
    if (product.uses_volume_price_tiers != 1) {
        return product.price == '0' ? product.price : formatPrice(product.price);
    }

    // If VPT exists
    if (product.volume_tier_min_max && product.volume_tier_min_max.length > 0) {
        const matchedTier = product.volume_tier_min_max.find(tier => {
            return qty >= tier.min && qty <= tier.max;
        });

        if (matchedTier) {
            return formatPrice(matchedTier.price);
        }
    }

    // fallback → RP
    return formatPrice(product.rp);
};

const formatPrice = (value) => {
    if (value == null || value === '') return '0';
    let num = parseFloat(value);
    return Number.isInteger(num) ? num.toString() : num.toString();
};

const filterInt = (value) => {
    if(/^(\-|\+)?([0-9]+|Infinity)$/.test(value))
        return Number(value);
    return NaN;
};
const filterFloat = (value) => {
    if(/^\d+(\.\d{1,2})?$/.test(value))
        return Number(value);
    return NaN;
};

const updateQuantity = (productId, value) => {
    quantities.value[productId] = value;
};

const addProductToCart = (product) => {
    if(store.state.brand.restrict_single_category_order == 1) {
        const productObj = product.hasVariants ? selectedVariant.value : product;
        const cartProducts = store.state.cartProducts;
        const categoryId = product.cat_id ?? product.category?.id;
        const hasDifferentCategoryProduct = cartProducts.some(cartProduct => 
            cartProduct.category_id !== categoryId
            );
            if (hasDifferentCategoryProduct) {
            Swal.fire({
                icon: "error",
                title: "Oops!",
                text: "You cannot add products from different categories at the same time",
            });
            return;
            }
        }
    let qtyValue = quantities.value[product.id] || product.min_pur_qty || 1;
    //Maximum Purchase Quantity does not greather than 6 digit  
    if(qtyValue > ProductMaxQuantity.value){
        toast.error('This Maximum purchase quantity for this product is 999999');//
    }
    else{ 
    
    let button = document.getElementById(product.id + '-button');
    let inputQuantity = document.getElementById(product.id + '-quantity');
    let productId = product.id;

    button.classList.remove('btn','btn-success','form-control');
    setCartButton(button,inputQuantity,'btn-success', t('adding'), true);

    // TODO when parent fucntion hits api request on its result set button property to Add to cart
    if (product.settings.decimelOrderAllow == 0) {
        quantity.value = filterInt(qtyValue);
        if (!Number.isInteger(quantity.value) || quantity.value < 1) {
            toast.error('Quantity must be a number greater than zero.');//
            setCartButton(button,inputQuantity,'btn-danger', t('error'), true);
            setTimeout(function() {
                button.classList.remove('btn','btn-danger','form-control');
                setCartButton(button,inputQuantity,'btn-success', t('add_to_cart'), false);
            }, 1000);
            return;
        }
    } else {
        quantity.value = filterFloat(qtyValue);
        if (isNaN(quantity.value) || quantity.value < 0.1) {
            toast.error('Quantity must be a positive number greater than zero');
            setCartButton(button,inputQuantity,'btn-danger', t('error'), true);
            setTimeout(function() {
                button.classList.remove('btn','btn-danger','form-control');
                setCartButton(button,inputQuantity,'btn-success', t('add_to_cart'), false);
            }, 1000);
            return;
        }
    }
    store.commit('SHOW_LOADER',true)
    ShopAPIService.addToCart({
            quantity: quantity.value,
            productId: productId
        },store.state.access_token).then((response) => {
            store.commit('SHOW_LOADER',false)
            if(response.data.hasOwnProperty("success")){
                eventBus.emit('refreshCart');
                toast.success(response.data.success);//
                setCartButton(button,inputQuantity,'btn-success', t('success'), true);
                setTimeout(()=>{
                    button.classList.remove('btn','btn-success','form-control');
                    setCartButton(button,inputQuantity,'btn-success', t('add_to_cart'), false);
                },1000);
            }
            else if(response.data.hasOwnProperty("error")){
                toast.error(response.data.error);//
                setCartButton(button,inputQuantity,'btn-danger', t('error'), true);
                setTimeout(()=>{
                    button.classList.remove('btn','btn-danger','form-control');
                    setCartButton(button,inputQuantity,'btn-success', t('add_to_cart'), false);
                },1000);
            }
        }).catch((error) => {
            store.commit('SHOW_LOADER',false)
            toast.error('Product not found');
            setCartButton(button,inputQuantity,'btn-danger', t('error'), true);
            setTimeout(()=>{
                button.classList.remove('btn','btn-danger','form-control');
                setCartButton(button,inputQuantity,'btn-success', t('add_to_cart'), false);
            },1000);
        });
    }
};
        
const setCartButton = (button, inputQuantity, btnClass, text, disable) => {
    // if (!button || !inputQuantity) return;
    button.innerHTML = text;
    button.className = `btn ${btnClass}`;
    button.disabled = disable;
    inputQuantity.disabled = disable;
};   
const openDetails = (product) => {
eventBus.emit('Product::openDetails',product);
};
</script>
<style>
@media (max-width: 995px) {
    .dataTables_scroll {
    overflow-x: auto; /* Enable horizontal scrolling */
    white-space: nowrap; /* Prevent table cell content from wrapping */
    }
}
@media (max-width: 768px) {
    .variants-listing-wrapper,
    .variants-listing-wrapper > .row,
    .variants-listing-wrapper > .row > .col-sm-12,
    .variants-listing-wrapper .dataTables_scroll.html-mobile-card-mode,
    .variants-listing-wrapper .html-mobile-card-portal,
    .variants-listing-wrapper .html-mobile-cards-list,
    .variants-listing-wrapper .html-mobile-card {
        width: 100% !important;
        min-width: 0;
        max-width: 100% !important;
        box-sizing: border-box;
    }
    .variants-listing-wrapper > .row {
        display: block;
        margin-right: 0;
        margin-left: 0;
    }
    .variants-listing-wrapper > .row > .col-sm-12 {
        display: block;
        flex: 0 0 100%;
        padding-right: 0;
        padding-left: 0;
    }
    .dataTables_scroll.html-mobile-card-mode {
        display: block;
        overflow-x: visible;
        white-space: normal;
    }
    .variants-listing-wrapper .html-mobile-card-value.variant-quantity-cell > .row {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        justify-content: flex-end;
        gap: 8px;
        margin-right: 0;
        margin-left: 0;
    }
    .variants-listing-wrapper .html-mobile-card-value.variant-quantity-cell > .row > [class*="col-"] {
        width: auto !important;
        max-width: none !important;
        padding: 0;
    }
    .variants-listing-wrapper .html-mobile-card-value.variant-quantity-cell > .row > [class*="col-"]:first-child {
        flex: 0 1 90px;
        min-width: 60px;
    }
    .variants-listing-wrapper .html-mobile-card-value.variant-quantity-cell > .row > [class*="col-"]:last-child {
        flex: 0 0 auto;
    }
    .variants-listing-wrapper .html-mobile-card-value.variant-quantity-cell input,
    .variants-listing-wrapper .html-mobile-card-value.variant-quantity-cell button {
        margin: 0;
    }
    .variants-listing-wrapper .html-mobile-card-value.variant-quantity-cell button {
        white-space: nowrap;
    }
}
    .img-fluid{
        max-width: 100%;
        height: auto;
        max-height: 50px;
    }
    th {
        width: 50px;
        text-align: center;
        font-weight: bold;
    }
    tr {
        height: 0px;
    }
    td {
        width: 50px;
        padding-top: 0px;
        padding-bottom: 0px;
        border-top-width: 0px;
        border-bottom-width: 0px;
        height: 0px;
    }
    addToCartBtn{
        font-size: 12;
    }
    .btn.btn-success {
     color: #ffffff;
     background-color: #1bac94;
     border-color: #1BC5BD;
     border-radius:0px;
}
 .btn.btn-success i {
     color: #ffffff;
}
 .btn.btn-success .svg-icon svg g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
     fill: #ffffff;
}
 .btn.btn-success .svg-icon svg:hover g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
}
 .btn.btn-success.dropdown-toggle:after {
     color: #ffffff;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled), .btn.btn-success:focus:not(.btn-text), .btn.btn-success.focus:not(.btn-text) {
     color: #ffffff;
     background-color: #0BB7AF;
     border-color: #0BB7AF;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled) i, .btn.btn-success:focus:not(.btn-text) i, .btn.btn-success.focus:not(.btn-text) i {
     color: #ffffff;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled) .svg-icon svg g [fill], .btn.btn-success:focus:not(.btn-text) .svg-icon svg g [fill], .btn.btn-success.focus:not(.btn-text) .svg-icon svg g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
     fill: #ffffff;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled) .svg-icon svg:hover g [fill], .btn.btn-success:focus:not(.btn-text) .svg-icon svg:hover g [fill], .btn.btn-success.focus:not(.btn-text) .svg-icon svg:hover g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled).dropdown-toggle:after, .btn.btn-success:focus:not(.btn-text).dropdown-toggle:after, .btn.btn-success.focus:not(.btn-text).dropdown-toggle:after {
     color: #ffffff;
}
 .btn.btn-success.disabled, .btn.btn-success:disabled {
     color: #ffffff;
     background-color: #1BC5BD;
     border-color: #1BC5BD;
}
 .btn.btn-success.disabled i, .btn.btn-success:disabled i {
     color: #ffffff;
}
 .btn.btn-success.disabled .svg-icon svg g [fill], .btn.btn-success:disabled .svg-icon svg g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
     fill: #ffffff;
}
 .btn.btn-success.disabled .svg-icon svg:hover g [fill], .btn.btn-success:disabled .svg-icon svg:hover g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
}
 .btn.btn-success.disabled.dropdown-toggle:after, .btn.btn-success:disabled.dropdown-toggle:after {
     color: #ffffff;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text), .btn.btn-success:not(:disabled):not(.disabled).active, .show > .btn.btn-success.dropdown-toggle, .show .btn.btn-success.btn-dropdown {
     color: #ffffff;
     background-color: #0BB7AF;
     border-color: #0BB7AF;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text) i, .btn.btn-success:not(:disabled):not(.disabled).active i, .show > .btn.btn-success.dropdown-toggle i, .show .btn.btn-success.btn-dropdown i {
     color: #ffffff;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text) .svg-icon svg g [fill], .btn.btn-success:not(:disabled):not(.disabled).active .svg-icon svg g [fill], .show > .btn.btn-success.dropdown-toggle .svg-icon svg g [fill], .show .btn.btn-success.btn-dropdown .svg-icon svg g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
     fill: #ffffff;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text) .svg-icon svg:hover g [fill], .btn.btn-success:not(:disabled):not(.disabled).active .svg-icon svg:hover g [fill], .show > .btn.btn-success.dropdown-toggle .svg-icon svg:hover g [fill], .show .btn.btn-success.btn-dropdown .svg-icon svg:hover g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text).dropdown-toggle:after, .btn.btn-success:not(:disabled):not(.disabled).active.dropdown-toggle:after, .show > .btn.btn-success.dropdown-toggle.dropdown-toggle:after, .show .btn.btn-success.btn-dropdown.dropdown-toggle:after {
     color: #ffffff;
}
</style>
